/* eslint-disable max-len */
import { AddVehicleToSearchHistoryRequest } from '@1po/1po-bff-fe-spec/generated/catalog/search_vehicle/request/AddVehicleToSearchHistoryRequest';
import { RemoveVehicleFromSearchHistoryRequest } from '@1po/1po-bff-fe-spec/generated/catalog/search_vehicle/request/RemoveVehicleFromSearchHistoryRequest';
import { VehicleDetail } from '@1po/1po-bff-fe-spec/generated/common/vehicle/VehicleDetail';
import {
  ADD_VEHICLE_TO_SEARCH_HISTORY_URL,
  CLEAR_SEARCH_HISTORY_URL,
  GET_AVAILABLE_DMS_SERVICES,
  GET_VEHICLE_SEARCH_HISTORY_URL,
  REMOVE_VEHICLE_FROM_SEARCH_HISTORY_URL,
} from '@1po/1po-bff-fe-spec/generated/common/WebsocketConstants';
import { GetAvailableDMSServicesRequest } from '@1po/1po-bff-fe-spec/generated/dms/request/GetAvailableDMSServicesRequest';
import { AddFavoriteTireBrandRequest } from '@1po/1po-bff-fe-spec/generated/user/request/AddFavoriteTireBrandRequest';
import { CancelNotificationRequest } from '@1po/1po-bff-fe-spec/generated/user/request/CancelNotificationRequest';
import { IgnoreNotificationRequest } from '@1po/1po-bff-fe-spec/generated/user/request/IgnoreNotificationRequest';
import { IsLoggedInRequest } from '@1po/1po-bff-fe-spec/generated/user/request/IsLoggedInRequest';
import { RemoveFavoriteTireBrandRequest } from '@1po/1po-bff-fe-spec/generated/user/request/RemoveFavoriteTireBrandRequest';
import { ResetFavoriteTireBrandSelectionRequest } from '@1po/1po-bff-fe-spec/generated/user/request/ResetFavoriteTireBrandSelectionRequest';
import { SelectSellerRequest } from '@1po/1po-bff-fe-spec/generated/user/request/SelectSellerRequest';
import { UpdateCatalogSettingsRequest } from '@1po/1po-bff-fe-spec/generated/user/request/UpdateCatalogSettingsRequest';
import { UpdateUserLanguageInfoRequest } from '@1po/1po-bff-fe-spec/generated/user/request/UpdateUserLanguageInfoRequest';
import { UpdateUserNotificationEstimateExpirationRequest } from '@1po/1po-bff-fe-spec/generated/user/request/UpdateUserNotificationEstimateExpirationRequest';
import { UpdateUserNotificationOrderStatusChangeRequest } from '@1po/1po-bff-fe-spec/generated/user/request/UpdateUserNotificationOrderStatusChangeRequest';
import { UpdateUserNotificationOrderValidationEmailAddressesRequest } from '@1po/1po-bff-fe-spec/generated/user/request/UpdateUserNotificationOrderValidationEmailAddressesRequest';
import { UpdateUserNotificationOrderValidationEmailRequest } from '@1po/1po-bff-fe-spec/generated/user/request/UpdateUserNotificationOrderValidationEmailRequest';
import { UpdateUserNotificationOrderValidationRequest } from '@1po/1po-bff-fe-spec/generated/user/request/UpdateUserNotificationOrderValidationRequest';
import { UpdateUserNotificationRequest } from '@1po/1po-bff-fe-spec/generated/user/request/UpdateUserNotificationRequest';

import {
  ADD_FAVORITE_TIRE_BRAND_URL,
  CANCEL_ALL_USER_NOTIFICATIONS_URL,
  CANCEL_USER_NOTIFICATION_URL,
  GET_USER_NOTIFICATIONS_URL,
  GET_USER_PROFILE_RECONNECT_URL,
  GET_USER_PROFILE_URL,
  GET_USER_SELLERS_URL,
  IGNORE_ALL_USER_NOTIFICATIONS_URL,
  IGNORE_USER_NOTIFICATION_URL,
  REMOVE_FAVORITE_TIRE_BRAND_URL,
  RESET_FAVORITE_TIRE_BRANDS_SELECTION_URL,
  SETUP_ESTIMATE_EXPIRATION_NOTIFICATIONS_URL,
  SETUP_ORDER_STATUS_NOTIFICATIONS_URL,
  SETUP_ORDER_VALIDATION_EMAIL_ADDRESSES_URL,
  SETUP_ORDER_VALIDATION_EMAIL_NOTIFICATION_URL,
  SETUP_ORDER_VALIDATION_NOTIFICATION_URL,
  SETUP_USER_NOTIFICATIONS_URL,
  UNSUBSCRIBE_ALL_NOTIFICATIONS_URL,
  UPDATE_CATALOG_SETTINGS_URL,
  UPDATE_USER_PROFILE_LANGUAGES_URL,
  UPDATE_USER_PROFILE_SELLER_URL,
} from '@1po/1po-bff-fe-spec/generated/user/UserURLs';
import { WebSocketAction } from 'utils/domainStore';
import { wsSendAction } from 'utils/domainStore/api';
import { Language } from 'utils/i18n/Language';

export const TRANSLATIONS_PATH = '/translations';

export function sendGetUserProfileRequest(request: IsLoggedInRequest): WebSocketAction {
  return wsSendAction(GET_USER_PROFILE_URL, request);
}

export function sendGetUserProfileReconnectRequest(): WebSocketAction {
  return wsSendAction(GET_USER_PROFILE_RECONNECT_URL, {});
}

export function sendGetAvailableDMSServicesRequest(request: GetAvailableDMSServicesRequest): WebSocketAction {
  return wsSendAction(GET_AVAILABLE_DMS_SERVICES, request);
}

export function sendUpdateUserProfileLanguagesRequest(
  webLanguage: Language,
  documentLanguage: Language,
  documentLanguageFallback?: Language,
): WebSocketAction {
  const request: UpdateUserLanguageInfoRequest = {
    webLanguage: webLanguage.key,
    documentLanguage: documentLanguage.key,
    documentLanguageFallback: documentLanguageFallback?.key,
  };

  return wsSendAction(UPDATE_USER_PROFILE_LANGUAGES_URL, request);
}

export function sendGetUserSellersRequest(): WebSocketAction {
  return wsSendAction(GET_USER_SELLERS_URL, null);
}

export function sendFetchUserNotificationsRequest(): WebSocketAction {
  return wsSendAction(GET_USER_NOTIFICATIONS_URL, null);
}

export function sendCancelNotificationRequest(request: CancelNotificationRequest): WebSocketAction {
  return wsSendAction(CANCEL_USER_NOTIFICATION_URL, request);
}

export function sendCancelAllNotificationsRequest(): WebSocketAction {
  return wsSendAction(CANCEL_ALL_USER_NOTIFICATIONS_URL, null);
}

export function sendIgnoreNotificationRequest(request: IgnoreNotificationRequest): WebSocketAction {
  return wsSendAction(IGNORE_USER_NOTIFICATION_URL, request);
}

export function sendIgnoreAllNotificationsRequest(): WebSocketAction {
  return wsSendAction(IGNORE_ALL_USER_NOTIFICATIONS_URL, null);
}

export function sendUpdateDhCatalogReferenceViewRequestSaga(request: UpdateCatalogSettingsRequest): WebSocketAction {
  return wsSendAction(UPDATE_CATALOG_SETTINGS_URL, request);
}

export function sendUpdateUserSellerRequest(request: SelectSellerRequest): WebSocketAction {
  return wsSendAction(UPDATE_USER_PROFILE_SELLER_URL, request);
}

export function sendGetVehicleHistorySubscriptionRequest(): WebSocketAction {
  return wsSendAction(GET_VEHICLE_SEARCH_HISTORY_URL, null);
}

export function addVehicleToSearchHistoryRequest(vehicle: VehicleDetail): WebSocketAction {
  const request: AddVehicleToSearchHistoryRequest = {
    vehicle,
  };
  return wsSendAction(ADD_VEHICLE_TO_SEARCH_HISTORY_URL, request);
}

export function sendRemoveVehicleFromSearchHistoryRequest(vehicleKey: string): WebSocketAction {
  const request: RemoveVehicleFromSearchHistoryRequest = {
    vehicleKey,
  };
  return wsSendAction(REMOVE_VEHICLE_FROM_SEARCH_HISTORY_URL, request);
}

export function sendClearSearchHistoryRequest(): WebSocketAction {
  return wsSendAction(CLEAR_SEARCH_HISTORY_URL, null);
}

export function sendAddFavoriteTireBrandForUserRequest(request: AddFavoriteTireBrandRequest): WebSocketAction {
  return wsSendAction(ADD_FAVORITE_TIRE_BRAND_URL, request);
}

export function sendRemoveFavoriteTireBrandForUserRequest(request: RemoveFavoriteTireBrandRequest): WebSocketAction {
  return wsSendAction(REMOVE_FAVORITE_TIRE_BRAND_URL, request);
}

export function sendResetFavoriteTireBrandForUserRequest(
  request: ResetFavoriteTireBrandSelectionRequest,
): WebSocketAction {
  return wsSendAction(RESET_FAVORITE_TIRE_BRANDS_SELECTION_URL, request);
}

export function sendUpdateNotificationsSettingsRequest(request: UpdateUserNotificationRequest): WebSocketAction {
  return wsSendAction(SETUP_USER_NOTIFICATIONS_URL, request);
}

export function sendUpdateNotificationsOnEstimateExpirationRequest(
  request: UpdateUserNotificationEstimateExpirationRequest,
): WebSocketAction {
  return wsSendAction(SETUP_ESTIMATE_EXPIRATION_NOTIFICATIONS_URL, request);
}

export function sendUpdateNotificationsOnOrderStatusChangeRequest(
  request: UpdateUserNotificationOrderStatusChangeRequest,
): WebSocketAction {
  return wsSendAction(SETUP_ORDER_STATUS_NOTIFICATIONS_URL, request);
}

export function sendUnsubscribeNotificationsRequest(): WebSocketAction {
  return wsSendAction(UNSUBSCRIBE_ALL_NOTIFICATIONS_URL, null);
}

export function sendUpdateOrderValidationNotificationRequest(
  request: UpdateUserNotificationOrderValidationRequest,
): WebSocketAction {
  return wsSendAction(SETUP_ORDER_VALIDATION_NOTIFICATION_URL, request);
}

export function sendUpdateOrderValidationEmailNotificationRequest(
  request: UpdateUserNotificationOrderValidationEmailRequest,
): WebSocketAction {
  return wsSendAction(SETUP_ORDER_VALIDATION_EMAIL_NOTIFICATION_URL, request);
}

export function sendUpdateOrderValidationEmailAddressesRequest(
  request: UpdateUserNotificationOrderValidationEmailAddressesRequest,
): WebSocketAction {
  return wsSendAction(SETUP_ORDER_VALIDATION_EMAIL_ADDRESSES_URL, request);
}
